import React from 'react';
import '../styles/Resume.css'

function Content() {
  return (
    <div className="content">
      <div className="resume-inner">
      <h2>Key Skills and Competencies</h2>
      <div className="skills-list">
        <ul>
          <li>Python</li>
          <li>C#</li>
          <li>C/C++</li>
          <li>SQL Server / Postgres</li>
          <li>R</li>
          <li>Javascript</li>
          <li>HTML/CSS</li>
          <li>Couchbase/N1QL</li>
          <li>Splunk</li>
          <li>Datadog</li>
          <li>RabbitMQ</li>
          <li>MongoDB</li>
          <li>Elastic Search</li>
          <li>Postman</li>
          <li>Mathematica</li>
          <li>Java</li>
          <li>LaTeX</li>
          <li>Matlab</li>
          <li>Node.js</li>
          <li>Neural Networks</li>
          <li>Typescript</li>
          <li>BoltJS (Slack Framework)</li>
          <li>REST APIs</li>
          <li>Git</li>
        </ul>
      </div>

      <h2>Educational Background</h2>
      <p><strong>2025-2026:</strong> Masters in mathematics, Universidad de Valencia, Politecnica de Valencia<br />
      Research Topic: The stochastic wave equation in spaces of mean square convergent stochastic processes</p>
      <p><strong>2020-2021:</strong> Post-Baccalaureate Studies in Mathematics, Georgia State University</p>
      <p><strong>2018-2019:</strong> Graduate Courses in Computer Engineering and Mathematics, Universitat Oberta de Catalunya, Barcelona, Spain <br />
        Research Topic: Random Matrices with Common Eigen-Properties</p>
      <p><strong>2017-2018:</strong> Graduate Courses in Advanced Mathematics, Universidad de Valencia/Universidad Politécnica de Valencia, Valencia, Spain <br />
        Research Topic: Classification of Shapes and Grassmannian Manifolds</p>
      <p><strong>2011-2015:</strong> BS Degree, Mathematics, University of Georgia, Athens, GA</p>
      <p><strong>2011-2015:</strong> BS Degree, Physics, University of Georgia, Athens, GA</p>

      <h2>Additional Information</h2>
      <h3>Nationality</h3>
      <div className="languages-list">
        <ul>
          <li className='citizenship'>Dual citizenship (US and Spain)</li>
        </ul>
      </div>
      <h3>Languages</h3>
      <div className="languages-list">
        <ul>
          <li>English - Native</li>
          <li>Spanish - Native</li>
          <li>Valencian/Catalan - Advanced written and spoken</li>
          <li>Italian - Intermediate written and spoken</li>
          <li>French - Intermediate written and spoken</li>
          <li>Russian - Familiarity with written language</li>
          <li>Farsi - Familiarity with spoken language</li>
        </ul>
      </div>

      <h2>Selected Employment Experience</h2>
      <p><strong>Application Engineer</strong> (11/2021 - 10/2025) <br />
        Cvent, Remote (Based in Atlanta, GA) <br />
        Working as an application engineer proficient in several languages and technologies.</p>

      <p><strong>Contract Engineer</strong> (03/2024 - Present) <br />
        Red Eagle Law, Remote <br />
        Developed web applications and internal tools for an immigration law firm.</p>

      <p><strong>Mathematics and Computer Science Teacher</strong> (09/2015 - 05/2022) <br />
        Elian’s British School, La Nucia, Spain <br />
        Lead teacher for A-Level Mathematics and Further Mathematics.</p>

      <p><strong>Research Assistant</strong> (05/2014 - 05/2015) <br />
        Geller Theory Group, University of Georgia, Athens, GA <br />
        Studied renormalization group implementation in D-wave devices.</p>

      <p><strong>Research Assistant</strong> (12/2013 - 11/2014) <br />
        Salerno Biochemistry Group, Kennesaw State University, Kennesaw, GA <br />
        Worked on time-dependent phosphorylation in eNOS.</p>

      <p><strong>Varsity Tutors</strong> (07/2017 - 11/2021) <br />
        Online/Remote <br />
        Virtual tutor for various levels of mathematics and physics.</p>

      <h2>Teaching Examples</h2>
      <ul className="teaching-examples">
        <li>
          <a href="https://www.youtube.com/watch?v=qZeBoLYRdtA&ab_channel=EliasMeana" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/qZeBoLYRdtA/0.jpg" alt="Deriving Centers of Mass" />
            Dynamics : Solving a classic mechanics problem involving inclined planes and pulleys
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/playlist?list=PLZaEjudfj3LWVtPkAQnGo13N-xhygKLgr" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/kyCsHftxT0Y/0.jpg" alt="Deriving Centers of Mass" />
            Series on Deriving Centers of Mass With Integral Formulations
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=ts_g7ADxP50&t=1707s" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/ts_g7ADxP50/0.jpg" alt="Solving Second Order Differential Equations" />
            Solving Second Order Homogeneous Differential Equations
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=OAiHkcCSgf0&t=5931s&ab_channel=EliasMeana" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/OAiHkcCSgf0/0.jpg" alt="Solving Second Order Differential Equations" />
            Solving First Order Nonhomogeneous Differential Equations With Integrating Factors
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=kkxi3G2PPnU&ab_channel=EliasMeana" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/kkxi3G2PPnU/0.jpg" alt="Solving Second Order Differential Equations" />
            Intuitive Development of the Second Derivative Test
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=iTtU6JtLnVY&ab_channel=EliasMeana" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/iTtU6JtLnVY/0.jpg" alt="Solving Second Order Differential Equations" />
            Intuitive Development of the Fundamental Theorem of Calculus
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=XcaFvFer4Hk&ab_channel=EliasMeana" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/XcaFvFer4Hk/0.jpg" alt="Solving Second Order Differential Equations" />
            Introduction to Complex Numbers : From Edexcel AS further mathematics
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=elIe2A4WP3k&feature=youtu.be" target="_blank" rel="noopener noreferrer">
            <img src="https://img.youtube.com/vi/elIe2A4WP3k/0.jpg" alt="Solving Second Order Differential Equations" />
            Telescoping series and the method of differences: From Edexcel A2 further mathematics
          </a>
        </li>
      </ul>
      </div>
    </div>
  );
}

export default Content;
